import { render } from "./NotificationPanel.vue?vue&type=template&id=59dfe8d8&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=59dfe8d8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/estatus-pedido-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dfe8d8"]])

export default __exports__